import "@phosphor-icons/web/regular/style.css"
import "@phosphor-icons/web/fill/style.css"

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import CarouselController        from "./controllers/carousel_controller"
import CatalogFiltersController  from "./controllers/catalog_filters_controller"
import CategorySearchController  from "./controllers/category_search_controller"
import ConfirmModalController    from "./controllers/confirm_modal_controller"
import DebouncedSubmitController from "./controllers/debounced_submit_controller"
import DropdownController        from "./controllers/dropdown_controller"
import FlashController           from "./controllers/flash_controller"
import GalleryController         from "./controllers/gallery_controller"
import LightboxController        from "./controllers/lightbox_controller"
import QuantityStepperController from "./controllers/quantity_stepper_controller"
import SidebarController         from "./controllers/sidebar_controller"
import SortableController        from "./controllers/sortable_controller"
import StarRatingController      from "./controllers/star_rating_controller"
import TabsController            from "./controllers/tabs_controller"
import TimezoneController        from "./controllers/timezone_controller"
import ToggleController          from "./controllers/toggle_controller"
import TreeController            from "./controllers/tree_controller"

const application = Application.start()
application.register("carousel",         CarouselController)
application.register("catalog-filters",  CatalogFiltersController)
application.register("category-search",  CategorySearchController)
application.register("confirm-modal",    ConfirmModalController)
application.register("debounced-submit", DebouncedSubmitController)
application.register("dropdown",         DropdownController)
application.register("flash",            FlashController)
application.register("gallery",          GalleryController)
application.register("lightbox",         LightboxController)
application.register("quantity-stepper", QuantityStepperController)
application.register("sidebar",          SidebarController)
application.register("sortable",         SortableController)
application.register("star-rating",      StarRatingController)
application.register("tabs",             TabsController)
application.register("timezone",         TimezoneController)
application.register("toggle",           ToggleController)
application.register("tree",             TreeController)
